module.exports = __webpack_public_path__ + "static/media/cards_example.086e208c.png";